export default __webpack_public_path__ + "static/media/cypress-gray.e1d61679.webp";